type Field = {
  label: string;
  unit: string;
  isDropdown?: boolean;
  dropdownOptions?: number[];
  showAbsolute?: boolean;
};

type InputSection = {
  displayName: string;
  allowedModes: string[];
  canToggle?: boolean;
  toggleKey?: string;
  fields: Record<string, Field>;
};

type InputSectionsConfig = Record<string, InputSection>;

export const inputSections: InputSectionsConfig = {
  buy: {
    displayName: 'Property Price',
    allowedModes: ['buy', 'manage'],
    fields: {
      property_price: {
        label: 'Property Price',
        unit: '$',
      },
    },
  },
  rent: {
    displayName: 'Rent',
    allowedModes: ['rent'],
    fields: {
      monthly_rent: {
        label: 'Monthly Rent',
        unit: '$',
      },
    },
  },
  debt: {
    displayName: 'Are you taking a loan?',
    allowedModes: ['buy', 'manage'],
    canToggle: true,
    toggleKey: 'is_loan_taken',
    fields: {
      loan_tenure: {
        label: 'Years',
        unit: 'years',
        isDropdown: true,
        dropdownOptions: [10, 15, 30],
      },
      down_payment: {
        label: 'Down Payment',
        unit: '$',
      },
      interest_rate: {
        label: 'Interest Rate',
        unit: '%',
      },
    },
  },
  operatingExpenses: {
    displayName: 'Annual Operating Expenses',
    allowedModes: ['buy', 'manage', 'rent'],
    fields: {
      management_fee: {
        label: 'Management Fee',
        unit: '$',
      },
      lodging_tax: {
        label: 'Lodging Tax',
        unit: '$',
      },
      hoa_fee_annual: {
        label: 'HOA Fee',
        unit: '$',
      },
      maintenance_annual: {
        label: 'Maintenance',
        unit: '$',
      },
      insurance_annual: {
        label: 'Insurance',
        unit: '$',
      },
      electricity_annual: {
        label: 'Electricity',
        unit: '$',
      },
      wifi_annual: {
        label: 'Wifi',
        unit: '$',
      },
      gas_annual: {
        label: 'Gas',
        unit: '$',
      },
      tech: {
        label: 'Tech',
        unit: '$',
      },
      marketing: {
        label: 'Marketing',
        unit: '$',
      },
      vacancy_cost: {
        label: 'Vacancy Cost',
        unit: '$',
      },
      others_annual: {
        label: 'Others',
        unit: '$',
      },
    },
  },
  taxes: {
    displayName: 'Taxes',
    allowedModes: ['buy', 'manage'],
    fields: {
      property_tax: {
        label: 'Property Tax',
        unit: '$',
      },
      income_tax: {
        label: 'Income Tax',
        unit: '$',
      },
      depreciation: {
        label: 'Depreciation',
        unit: '$',
      },
    },
  },
  startupCost: {
    displayName: 'Startup Cost',
    allowedModes: ['buy', 'manage', 'rent'],
    fields: {
      remodelling: {
        label: 'Remodelling',
        unit: '$',
      },
      furnishing_cost: {
        label: 'Home Furnishing',
        unit: '$',
      },
      closing_cost: {
        label: 'Closing Costs',
        unit: '$',
      },
    },
  },
  sell: {
    displayName: 'Sell',
    allowedModes: ['buy', 'manage'],
    canToggle: true,
    toggleKey: 'wanna_sell',
    fields: {
      property_appreciation_rate: {
        label: 'Appreciation',
        unit: '%',
        showAbsolute: true,
      },
      cost_to_sell: {
        label: 'Cost to Sell',
        unit: '$',
      },
      holding_period_in_years: {
        label: 'Holding Period',
        unit: 'years',
      },
    },
  },
  manage: {
    displayName: 'Manage',
    allowedModes: ['buy', 'manage'],
    fields: {
      owner_occupied_days: {
        label: "Owner's Occupied Days",
        unit: 'days',
      },
      management_fee_earned: {
        label: 'Management Fee (Earn)',
        unit: '$',
      },
    },
  },
};
